import { render, staticRenderFns } from "./LoginProfileButtons.vue?vue&type=template&id=03ce3531&scoped=true&"
import script from "./LoginProfileButtons.vue?vue&type=script&lang=js&"
export * from "./LoginProfileButtons.vue?vue&type=script&lang=js&"
import style0 from "./LoginProfileButtons.vue?vue&type=style&index=0&id=03ce3531&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ce3531",
  null
  
)

export default component.exports